import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { AppState } from '../../../../interfaces/app-state.interface';
import { GetUserAcceptanceTerm } from '../../../../interfaces/operational-limit/operational-limit.interface';
import { OperationalLimitAction } from '../../../../state-management/operational-limit/operational-limit.action';
import { BanksAction } from '../../../../state-management/banks/banks.action';
import { Token } from '../../../../models/authentication/token.model';

@AutoUnsubscribe()
@Component({
  selector: 'hub-lo-delete-account-step',
  styleUrls: ['./delete-account-step.component.scss'],
  templateUrl: 'delete-account-step.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class HubLoDeleteAccountComponent implements OnInit, OnChanges, OnDestroy {
  @Input() public financialPending: boolean | null = null;
  @Input() public operationalLimit: GetUserAcceptanceTerm;
  @Input() public token: Token;
  @Output() public closeDrawer = new EventEmitter<void>();
  @Output() public back = new EventEmitter<void>();
  public revokeError = false;
  public deleteError = false;
  public completed = false;
  private rejectTermSubscription: Subscription;
  private deleteSubscription: Subscription;
  private dispatched: boolean = false;

  public get hasError(): boolean {
    return this.revokeError || this.deleteError;
  }

  constructor(
    private store: Store<AppState>,
    private actions$: Actions,
  ) {}

  public ngOnInit(): void {
    this.tryRevokeAndDelete();
  }

  public ngOnChanges(): void {
    this.tryRevokeAndDelete();
  }

  private tryRevokeAndDelete(): void {
    if (this.dispatched || this.hasError) {
      return;
    }
    if (this.financialPending === null) {
      return;
    }
    if (!this.operationalLimit?.cblc) {
      this.revokeError = true;
      return;
    }
    if (!this.token) {
      this.revokeError = true;
      return;
    }
    if (this.financialPending === true) {
      return;
    }
    this.dispatched = true;
    this.rejectTermSubscription = this.actions$
      .pipe(
        ofType(
          OperationalLimitAction.rejectTermSuccess,
          OperationalLimitAction.rejectTermError,
        ),
        take(1),
      )
      .subscribe((action: Action) => {
        if (action.type === OperationalLimitAction.rejectTermError) {
          this.revokeError = true;
          return;
        }
        this.deleteAccount();
      });
    this.store.dispatch({
      type: OperationalLimitAction.rejectTerm,
      payload: { cblc: this.operationalLimit.cblc },
    });
  }

  private deleteAccount(): void {
    this.deleteSubscription = this.actions$
      .pipe(
        ofType(BanksAction.deleteItemSuccess, BanksAction.deleteItemError),
        take(1),
      )
      .subscribe((action: Action) => {
        if (action.type === BanksAction.deleteItemError) {
          this.deleteError = true;
          return;
        }
        this.completed = true;
        this.store.dispatch({ type: OperationalLimitAction.getAcceptanceTerm });
      });
    this.store.dispatch({
      type: BanksAction.deleteItem,
      payload: {
        value: this.operationalLimit.accountId,
        token: this.token,
      },
    });
  }

  public retry(): void {
    if (this.deleteError) {
      this.deleteError = false;
      this.deleteAccount();
    } else {
      this.revokeError = false;
      this.dispatched = false;
      this.tryRevokeAndDelete();
    }
  }

  // não remover, necessário para o funcionamento correto do @AutoUnsubscribe
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method, @typescript-eslint/no-empty-function
  public ngOnDestroy(): void {}
}
